import React, { useCallback } from 'react';
import cx from 'classnames';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, Icon, Label } from '@atlas/ui';

export const WithdrawalResultPopup = ({ data = {}, id }) => {
  const { errorType = false, headerTitle, successType = false, text, title } = data;

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className={cx(successType && 'success-modal', errorType && 'error-modal')}
      headerTitle={headerTitle}
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div className="popup__content">
        {successType && <Icon className="success-modal__icon" name="success" />}
        {errorType && <Icon className="error-modal__icon" name="error" />}
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </DefaultPopup>
  );
};
